import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { getEntityConfig, type EntityConfig } from '../../config/entity-config';
import { EntityEditPageComponent } from '../entity-edit/entity-edit-page.component';

/**
 * Route component for /manage/:entityKey/:id/edit. Renders custom edit or default EntityEditPageComponent.
 */
@Component({
  selector: 'app-management-edit',
  standalone: true,
  imports: [CommonModule, EntityEditPageComponent],
  template: `
    @if (entityConfig(); as config) {
      @if (config.editComponent) {
        <ng-container *ngComponentOutlet="config.editComponent; inputs: { entityConfig: config, id: id() }" />
      } @else {
        <app-entity-edit-page [entityConfig]="config" [id]="id()" />
      }
    } @else {
      <p>Unknown entity.</p>
    }
  `,
})
export class ManagementEditComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private sub: Subscription | null = null;
  readonly entityConfig = signal<EntityConfig | undefined>(undefined);
  readonly id = signal('');

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const key = params.get('entityKey') ?? '';
      this.entityConfig.set(getEntityConfig(key));
      this.id.set(params.get('id') ?? '');
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
